import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-846e0b60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fs-5 mb-0" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-6" }
const _hoisted_4 = { class: "d-flex justify-content-start align-items-center" }
const _hoisted_5 = { class: "ms-1" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "d-flex align-items-center justify-content-between mb-4" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "buttons d-flex justify-content-begin align-items-center" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "feedback", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_16 = { class: "d-flex justify-content-start align-items-center" }
const _hoisted_17 = {
  key: 0,
  class: "ms-1"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "edit", -1))
const _hoisted_19 = { key: 0 }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "row row-content mb-4" }
const _hoisted_24 = { class: "col-auto" }
const _hoisted_25 = { class: "row row-content mb-4" }
const _hoisted_26 = { class: "row row-content mb-4" }
const _hoisted_27 = { class: "form-buttons col-12 d-flex justify-content-end align-items-center ms-4" }
const _hoisted_28 = {
  type: "submit",
  class: "btn btn-primary"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "delete", -1))
const _hoisted_30 = [
  _hoisted_29
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseCardHeader = _resolveComponent("BaseCardHeader")!
  const _component_InputCheckboxBoolean = _resolveComponent("InputCheckboxBoolean")!
  const _component_dp_form = _resolveComponent("dp-form")!
  const _component_PimFeedbackPanelOld = _resolveComponent("PimFeedbackPanelOld")!
  const _component_BaseCardBody = _resolveComponent("BaseCardBody")!
  const _component_base_modal_button = _resolveComponent("base-modal-button")!
  const _component_BaseCard = _resolveComponent("BaseCard")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_InputTextEditor = _resolveComponent("InputTextEditor")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BaseCard, { class: "category text-bg-light border-light mb-3" }, {
      default: _withCtx(() => [
        _createVNode(_component_BaseCardHeader, { class: "p-2" }, {
          default: _withCtx(() => [
            _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.namedTextFramgmentType?.description), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_BaseCardBody, { class: "p-2" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", {
                        class: _normalizeClass(_ctx.externalContentBadgeClass)
                      }, _toDisplayString(_ctx.$t('externalContent')), 3),
                      _createElementVNode("div", _hoisted_5, [
                        _withDirectives(_createVNode(_component_dp_form, {
                          as: 'showExternalForm' + _ctx.textFragmentNameCode,
                          novalidate: ""
                        }, {
                          default: _withCtx(({ errors }) => [
                            _createVNode(_component_InputCheckboxBoolean, {
                              modelValue: _ctx.externalShow,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.externalShow) = $event)),
                              label: _ctx.$t('show'),
                              name: 'is_show_external_' + _ctx.textFragmentNameCode,
                              errors: errors
                            }, null, 8, ["modelValue", "label", "name", "errors"])
                          ]),
                          _: 1
                        }, 8, ["as"]), [
                          [_vShow, _ctx.fragmentUI.isReady()]
                        ])
                      ])
                    ]),
                    (_ctx.namedTextFragments && _ctx.namedTextFragments.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.namedTextFragments, (fragment) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: fragment,
                              class: "mb-3"
                            }, [
                              _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", {
                                  innerHTML: fragment.text_fragment.fragment?.content,
                                  class: "value me-2"
                                }, null, 8, _hoisted_8),
                                _createElementVNode("div", _hoisted_9, [
                                  _createElementVNode("button", {
                                    class: "btn btn-sm btn-icon btn-primary ms-1",
                                    onClick: _withModifiers(($event: any) => (_ctx.toggleIsShowFeedbackForFragmentWithId(fragment.id)), ["prevent"])
                                  }, _hoisted_12, 8, _hoisted_10)
                                ])
                              ]),
                              (_ctx.isShowFeedbackForFragmentWithId === fragment.id)
                                ? (_openBlock(), _createBlock(_component_PimFeedbackPanelOld, {
                                    key: 0,
                                    "is-general-remark": false,
                                    "field-code": fragment.text_fragment.code,
                                    "text-fragment-id": fragment.id,
                                    onSubmitPimFeedback: _ctx.submitPimFeedback,
                                    onSubmitPimFeedbackCancel: _ctx.submitPimFeedbackCancel
                                  }, null, 8, ["field-code", "text-fragment-id", "onSubmitPimFeedback", "onSubmitPimFeedbackCancel"]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.$t('noContentFound')), 1))
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.ownContentBadgeClass)
                        }, _toDisplayString(_ctx.$t('ownContent')), 3),
                        (_ctx.customerPropertyToShow)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _withDirectives(_createVNode(_component_dp_form, {
                                as: 'showOwnForm' + _ctx.textFragmentNameCode,
                                novalidate: ""
                              }, {
                                default: _withCtx(({ errors }) => [
                                  _createVNode(_component_InputCheckboxBoolean, {
                                    modelValue: _ctx.ownContentShow,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ownContentShow) = $event)),
                                    label: _ctx.$t('show'),
                                    name: 'is_show_external_' + _ctx.textFragmentNameCode,
                                    errors: errors
                                  }, null, 8, ["modelValue", "label", "name", "errors"])
                                ]),
                                _: 1
                              }, 8, ["as"]), [
                                [_vShow, _ctx.fragmentUI.isReady()]
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_base_modal_button, {
                          class: "btn btn-hover icon-link",
                          "modal-id": _ctx.editCustomerContentModalId
                        }, {
                          default: _withCtx(() => [
                            _hoisted_18,
                            _createTextVNode(_toDisplayString(_ctx.$t('editContent')), 1)
                          ]),
                          _: 1
                        }, 8, ["modal-id"])
                      ])
                    ]),
                    (_ctx.customerPropertyToShow)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createElementVNode("div", {
                            innerHTML: _ctx.customerPropertyToShow.value
                          }, null, 8, _hoisted_20)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.$t('noContentFound')), 1))
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_base_modal, {
      "modal-id": _ctx.editCustomerContentModalId,
      title: _ctx.$t('ownContent'),
      "dialog-classes": "modal-lg",
      "no-footer": ""
    }, {
      default: _withCtx(() => [
        (_ctx.fragmentUI.isReady())
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createVNode(_component_dp_form, {
                onSubmit: _ctx.submitCustomerContent,
                as: "form",
                novalidate: ""
              }, {
                default: _withCtx(({ errors }) => [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_InputSelect, {
                          modelValue: _ctx.editableCustomerProperty.strategy_code,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editableCustomerProperty.strategy_code) = $event)),
                          name: _ctx.editableCustomerProperty.strategy_code,
                          options: _ctx.propertStrategyOptions,
                          selectText: _ctx.$t('selectText'),
                          hidden: true,
                          "can-clear": "",
                          errors: errors
                        }, null, 8, ["modelValue", "name", "options", "selectText", "errors"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_InputTextEditor, {
                        modelValue: _ctx.editableCustomerProperty.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editableCustomerProperty.value) = $event)),
                        label: _ctx.namedTextFramgmentType?.description,
                        name: "ownContent",
                        class: "col-12",
                        errors: errors
                      }, null, 8, ["modelValue", "label", "errors"])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("button", _hoisted_28, _toDisplayString(_ctx.$t('save')), 1),
                        _createElementVNode("button", {
                          class: "btn btn-icon btn-danger ms-2 me-3",
                          onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.confirmDeleteOwnContent && _ctx.confirmDeleteOwnContent(...args)), ["prevent"]))
                        }, _hoisted_30)
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modal-id", "title"])
  ], 64))
}